import { useUserAppConfigStore } from './stores/useUserAppConfigStore'

// Hardcoded array of dashboard admin user IDs
const DASHBOARD_ADMIN_USER_IDS: string[] = [
   // Add specific user IDs here that should have dashboard admin access
   // Example: 'user-id-1', 'user-id-2', 'user-id-3'
   '51632778-9847-4f79-b220-ebf204078ed8' //UAT
]

/**
 * Hook to check if the current user is a dashboard administrator
 *
 * @returns boolean - true if user is admin AND their userId is in the dashboard admin list
 */
export const useIsDashboardAdmin = (): boolean => {
   const userStore = useUserAppConfigStore()

   // First check if user is admin
   const isAdmin = Boolean(userStore.userDetails?.isAdmin)

   // If not admin, return false immediately
   if (!isAdmin) {
      return false
   }

   // If admin, check if userId is in the dashboard admin list
   const userId = userStore.userDetails?.userId

   if (!userId) {
      return false
   }

   const result = DASHBOARD_ADMIN_USER_IDS.includes(userId)
   return result
}
